export const LOGIN_LOADING = "adminlogin/adminsignin/loading";
export const LOGIN_SUCCESS = "adminlogin/adminsignin/success";
export const LOGIN_ERROR = "adminlogin/adminsignin/error";
export const SIGN_OUT = "adminlogin/adminsignout";

 
